import { CustomUser } from '@/models/custom-user.model';

export function getUserHelper(): CustomUser | null {
    const userStorage = localStorage.getItem('user');

    if (!userStorage) {
        return null;
    }

    const user: CustomUser = JSON.parse(userStorage);

    return user as CustomUser;
}
